import { render, staticRenderFns } from "./OutrightOutcomes.vue?vue&type=template&id=5dea3d92&class=sgame-odds-box"
import script from "./OutrightOutcomes.vue?vue&type=script&lang=js"
export * from "./OutrightOutcomes.vue?vue&type=script&lang=js"
import style0 from "./OutrightOutcomes.vue?vue&type=style&index=0&id=5dea3d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports